/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-19 21:32:24
 * @LastEditTime: 2022-01-21 17:55:47
 * @LastEditors: zhao - 🍉
 * @Description: 更换顾问
 * @FilePath: /zhzj-admin/src/page/CustomerServices/CustomerList/components/ReplaceSalesModal.jsx
 */

import { message, Modal, Select } from 'antd';
import React, { useState, useRef } from 'react'
import { CustomCol, CustomRow } from '../../../../components/Custom';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchWechatServicesCustomerSalesUpdate } from '../../../../services/wechatServices';

const ReplaceSales = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newSalesAccount, setNewSalesAccount] = useState();
    const [customerData, setCustomerData] = useState({});
    let callback = useRef(null);

    const open = (customerData) => {
        setVisible(true)
        setCustomerData(customerData)
        return new Promise((resolve, reject) => {
            callback.current = resolve
        })
    }
    const close = () => {
        setVisible(false)
    }

    const postSubmit = (data) => {
        setLoading(true)
        return fetchWechatServicesCustomerSalesUpdate(data).then(res => {
           message.success('更换成功')
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleSubmit = () => {
        if (loading) return
        if (!newSalesAccount) return message.warning('请选择新顾问')
        const data = {
            newGuideAccount: newSalesAccount,
            // newGuideOpenid: string,
            oldGuideAccount: customerData.guide_account,
            // oldGuideOpenid: string,
            openid: customerData.openid,
        }
        postSubmit(data).then(() => {
            callback.current()
            close()
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="更换顾问" 
            width={650} 
            visible={visible} 
            confirmLoading={loading}
            onCancel={close} 
            onOk={handleSubmit}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <CustomRow divider>
                        <CustomCol label="当前顾问" colStyle={{width: 500}}>
                            <span style={{ paddingLeft:6 }}>{customerData.guide_account}</span>
                        </CustomCol>
                    
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="新顾问" colStyle={{width: 500}}>
                            <Select style={{width: '100%'}} onChange={setNewSalesAccount}>
                                {(props.salesList || []).map(e => <Select.Option key={e.value} value={e.value}>{e.title}</Select.Option>)}
                            </Select>
                        </CustomCol>
                        
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default ReplaceSales



// WEBPACK FOOTER //
// ./src/page/CustomerServices/CustomerList/components/ReplaceSalesModal.jsx